export const CURRENCY = {
  USA: '$',
  CANADA: 'C$'
};
